import { SmartLinkEntityType } from 'src/app/core/dtos/enums/smart-link-entity-type';
import { ISmartLink } from 'src/app/core/models/i-smart-link';

export type SmartLinkTargetBox =
  | 'manager'
  | 'fund'
  | 'sector'
  | 'assetClass'
  | 'investmentTrust'
  | 'privateMarketsFund';

export interface ISmartLinkTarget {
  label: string;
  // null: no Related data box for this pair — accepting records the server-side decision only.
  box: SmartLinkTargetBox | null;
  order: number;
  // AMR path appended to appConfig.amrUrl. Omitted where AMR has no per-record page for the type.
  infoRoute?: string;
  // NOTE: PM-165: whether a suggestion already present in its box should drop out of the queue
  // outright. False only for Private Markets funds, where accepting an already-tagged fund can
  // still insert a body link (ADR-0006) — hiding it would silently remove that tag-then-accept
  // path. Meaningless where box is null: nothing to compare a record against.
  hideWhenAlreadyLinked: boolean;
}

export function smartLinkTargetKey(
  item: Pick<ISmartLink, 'target_db' | 'entity_type'>,
): string {
  return `${item.target_db}:${item.entity_type}`;
}

// Group order mirrors the box order in the Selected view.
// TODO DEV: the 'citywire:*' wire values are provisional until the PM-109 smart-linking
// contract confirms them — update only this table when it firms up.
export const SMART_LINK_TARGETS: Record<string, ISmartLinkTarget> = {
  [`citywire:${SmartLinkEntityType.MANAGER}`]: {
    label: 'Managers',
    box: 'manager',
    order: 0,
    infoRoute: '/manager/',
    hideWhenAlreadyLinked: true,
  },
  [`citywire:${SmartLinkEntityType.FUND}`]: {
    label: 'Funds & ETFs',
    box: 'fund',
    order: 1,
    infoRoute: '/fund/',
    hideWhenAlreadyLinked: true,
  },
  [`citywire:${SmartLinkEntityType.SECTOR}`]: {
    label: 'Sectors',
    box: 'sector',
    order: 2,
    hideWhenAlreadyLinked: true,
  },
  [`citywire:${SmartLinkEntityType.ASSET_CLASS}`]: {
    label: 'Asset classes',
    box: 'assetClass',
    order: 3,
    hideWhenAlreadyLinked: true,
  },
  [`citywire:${SmartLinkEntityType.INVESTMENT_TRUST}`]: {
    label: 'Investment trusts',
    box: 'investmentTrust',
    order: 4,
    hideWhenAlreadyLinked: true,
  },
  [`private_markets:${SmartLinkEntityType.FUND}`]: {
    label: 'Private Markets funds',
    box: 'privateMarketsFund',
    order: 5,
    hideWhenAlreadyLinked: false,
  },
  [`private_markets:${SmartLinkEntityType.MANAGEMENT_GROUP}`]: {
    label: 'Management groups',
    box: null,
    order: 6,
    hideWhenAlreadyLinked: false,
  },
};
